import React from 'react'
import SuccessAddSurgicalOrderLayout from 'presentation/doctor/layouts/AddSurgicalOrderV2/SuccessAddSurgicalOrder'

function SuccessAddSurgicalOrder() {
  return <SuccessAddSurgicalOrderLayout />
}

export default SuccessAddSurgicalOrder
